// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  width: 100%;
  margin: auto;
  flex-grow: 1;
  display: flex;
}

.main__wrapper {
  width: 100%;
  margin: 0 auto;
  padding: 0 40px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
}

.main__container {
  position: relative;
  width: 100%;
}

.main__container-img {
  display: block;
  width: 100%;
  max-width: 100%;
  object-fit: cover;
  height: 600px;
}

.main__arrow {
  position: absolute;
  top: 90%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  cursor: pointer;
}

@media (hover: hover) {
  .main__arrow:hover{
    background-color: #b6bcbd;
    border-radius: 50%;
  }
}

.main__left-arrow {
  left: 10px;
}

.main__right-arrow {
  right: 10px;
}

.main__blok-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  width: 80%;
}

.main__title {
  margin: 0;
  padding: 0;
  color: #073042;
  font-family: Oswald-Light, sans-serif;
  font-weight: 400;
  line-height: 1.55;
  font-size: 30px;
}

.main__text {
  font-family: Oswald-Light, sans-serif;
  font-weight: 300;
  color: #073042;
  font-size: 20px;
  line-height: 1.35;
  padding: 0 20px;
  text-align: left;
}

@media screen and (max-width: 1160px) {
  .main__container-img {
    height: 500px;
  }
  .main__wrapper {
    max-width: 868px;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .main__blok-info {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .main__wrapper {
    padding: 0 40px 10px;
    gap: 16px;
  }

  .main__container-img {
    height: 300px;
  }

  .main__title {
    font-size: 30px;
    padding: 0;
  }
  .main__text {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Main/Main.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".main {\n  width: 100%;\n  margin: auto;\n  flex-grow: 1;\n  display: flex;\n}\n\n.main__wrapper {\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 40px 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 30px;\n}\n\n.main__container {\n  position: relative;\n  width: 100%;\n}\n\n.main__container-img {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  object-fit: cover;\n  height: 600px;\n}\n\n.main__arrow {\n  position: absolute;\n  top: 90%;\n  transform: translateY(-50%);\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n}\n\n@media (hover: hover) {\n  .main__arrow:hover{\n    background-color: #b6bcbd;\n    border-radius: 50%;\n  }\n}\n\n.main__left-arrow {\n  left: 10px;\n}\n\n.main__right-arrow {\n  right: 10px;\n}\n\n.main__blok-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 5px;\n  width: 80%;\n}\n\n.main__title {\n  margin: 0;\n  padding: 0;\n  color: #073042;\n  font-family: Oswald-Light, sans-serif;\n  font-weight: 400;\n  line-height: 1.55;\n  font-size: 30px;\n}\n\n.main__text {\n  font-family: Oswald-Light, sans-serif;\n  font-weight: 300;\n  color: #073042;\n  font-size: 20px;\n  line-height: 1.35;\n  padding: 0 20px;\n  text-align: left;\n}\n\n@media screen and (max-width: 1160px) {\n  .main__container-img {\n    height: 500px;\n  }\n  .main__wrapper {\n    max-width: 868px;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  .main__blok-info {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .main__wrapper {\n    padding: 0 40px 10px;\n    gap: 16px;\n  }\n\n  .main__container-img {\n    height: 300px;\n  }\n\n  .main__title {\n    font-size: 30px;\n    padding: 0;\n  }\n  .main__text {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
